import { Relations } from '../enums/Relations';
import { FilterOption } from "../interfaces/FilterOption";
import { Filters } from "../interfaces/Filters";

class NameHelper {
  public static createPreferenceNameFromFilters(filters: Filters): string {
    const nameParts: string[] = [];

    const addAttributes = (attributeName: string, data: FilterOption[] | { name: string }[]) => {
      const attributeNames = data.map(item => item.name).join(', ');

      if (attributeNames) {
        nameParts.push(`${attributeName}: ${attributeNames}`);
      }

    };

    addAttributes('Types', filters.types);
    addAttributes('Sites', filters.sites);
    addAttributes('Tags', filters.tags.map((tag) => ({ name: tag.attributes.name })));

    if (filters.hasTips !== null) {
      nameParts.push(`Tips Content: ${filters.hasTips ? 'With Tips' : 'Without Tips'}`);
    }

    return nameParts.join('; ');
  }

  public static createNameFromFilters(filters: Filters): string {
    if (0 === filters.types.length && 0 === filters.sites.length &&  !filters.date) {
      return '';
    }

    const nameParts: string[] = ['All'];

    if (filters.types.length > 0) {
      nameParts.push(filters.types.map(type => type.name).join(' and '));
    }

    nameParts.push('Articles');

    if (filters.sites.length > 0) {
      nameParts.push(`from ${filters.sites.map(site => site.name).join(' and ')}`);
    }

    if (filters.date) {
      nameParts.push(`in ${filters.date.name}`);
    }

    return nameParts.join(' ');
  }

  public static getNameFromEntity(variation: any, attribute: Relations): string {
    return 'data' in variation.attributes[attribute]
      ? variation.attributes[attribute].data.attributes.name
      : variation.attributes[attribute].name;
  }
}

export default NameHelper;
